{
  "next": "Další",
  "previous": "Předchozí"
}
